export default __webpack_public_path__ + "static/media/closewhite.239ce48e.svg";